import React from 'react'
import { BsDownload, BsPencil } from 'react-icons/bs'
import { FaCaretDown, FaPrint } from 'react-icons/fa6'
import { FiRefreshCcw } from 'react-icons/fi'
import { IoSettingsOutline } from 'react-icons/io5'

const TrialBalance = () => {
  return (
     <>
          <div className='__znDe_mainBx'>
            <div>
              <div className='panel-heading'>
                <h2><span>General Ledger</span></h2>
    
                <div className='panel-ctrls report-control'>
                  <div class="dropdown">
                    <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      This Year
                      <FaCaretDown />
                    </button>
                    <ul class="dropdown-menu">
                      <li><a class="dropdown-item" href="#">Action</a></li>
                      <li><a class="dropdown-item" href="#">Another action</a></li>
                      <li><a class="dropdown-item" href="#">Something else here</a></li>
                    </ul>
                  </div>
    
                  <button className='__bxs_srBtn'>
                    <IoSettingsOutline />
                  </button>
    
                  <button className='__bxs_srBtn'>
                    <BsDownload />
                  </button>
    
                  <button className='__bxs_srBtn'>
                    <FaPrint />
                  </button>
    
                  <button className='__bxs_srBtn'>
                    <BsPencil />
                  </button>
    
                  <button className='__bxs_srBtn'>
                    <FiRefreshCcw />
                  </button>
                </div>
              </div>
            </div>
    
            <div className='__hrlMain_dix'>
              <div className='voucher report-voucher  printable ng-table-reports'>
                <div className='__mainPanel'>
                  <div className="panel panel-primary">
                    <div className='panel-body '>
                      <div className='py-20 block-ui block-ui-anim-fade'>
                        <div className='clear-both text-center p-10'>
                          <div class="__hrlMx_head" >
                            <p>Eminence</p>
                            <h4>Trial Balance</h4>
                            <h5><span>Basis</span> : Accrual</h5>
                            <h5>As of &nbsp;&nbsp;31/01/2025</h5>
                          </div>
                        </div>
    
                        <div className='clear-both'>
                          <div className='report-table w-100'>
                            <table className='table report-table w-100 table-hover ng-table'>
                              <thead>
                                <tr className='ng-table-sort-header'>
                                  <th className='header text-left'>
                                    <div className='ng-table-header'>
                                      <span>Account</span>
                                    </div>
                                  </th>
    
                                  <th className='header text-end pr-important-10'>
                                    <div className='ng-table-header'>
                                      <span>Debit</span>
                                    </div>
                                  </th>
    
                                  <th className='header text-end pr-important-10'>
                                    <div className='ng-table-header'>
                                      <span>Credit</span>
                                    </div>
                                  </th>
    
                                </tr>
                              </thead>
    
                              <tbody>
                                <tr className='ledger in ledgers cursor-pointer'>
                                  <td className='text-left'>Accounts Payable</td>
                                  <td className='text-end'></td>
                                  <td className='text-end'>16,923.00</td>
                                </tr>

                                <tr className='ledger in ledgers cursor-pointer'>
                                  <td className='text-left'>Accounts Receivable</td>
                                  <td className='text-end'>2,30,800.00</td>
                                  <td className='text-end'></td>
                                </tr>

                                <tr className='ledger in ledgers cursor-pointer'>
                                  <td className='text-left'>Eminence- ICICI Bank</td>
                                  <td className='text-end'>2,80,000.00</td>
                                  <td className='text-end'></td>
                                </tr>

                                <tr className='ledger in ledgers cursor-pointer'>
                                  <td className='text-left'>Petty Cash</td>
                                  <td className='text-end'></td>
                                  <td className='text-end'></td>
                                </tr>

                                <tr className='ledger in ledgers cursor-pointer'>
                                  <td className='text-left'>Purchase A/c</td>
                                  <td className='text-end'>86,923.00</td>
                                  <td className='text-end'></td>
                                </tr>

                                <tr className='ledger in ledgers cursor-pointer'>
                                  <td className='text-left'>Sales</td>
                                  <td className='text-end'></td>
                                  <td className='text-end'>5,80,800.00</td>
                                </tr>

                                <tr className='hover-muted f15 row-total'>
                                  <td className='text-left'>Total</td>
                                  <td className='text-end'>5,97,723.00</td>
                                  <td className='text-end'>5,97,723.00</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>

    // <div className='__hrlMain_dix'>
    //   <div className='__inr_hrlMxs'>
    //     <div>
    //       <div className='__hrlMx_head'>
    //         <p>Eminence</p>
    //         <h4>Trial Balance</h4>
    //         <h5><span>Basis</span> : Accrual</h5>
    //         <h5>As of &nbsp;&nbsp;31/01/2025</h5>
    //       </div>

    //       <table className='table-no-border table-hover fixed-first-column zi-table trail-bal tb-comparison-table financial-comparison' style={{ margin: '0 auto 10px' }}>
    //         <thead>
    //           <tr>
    //             <th className='text-start sortable   ascending  '>
    //               <button className='btn srt-btn'>
    //                 <div className='position-relative d-flex align-items-center '>
    //                   <div title='Account'>Account</div>
    //                 </div>
    //               </button>
    //             </th>

    //             <th className='text-end '>
    //               <button className='btn srt-btn'>
    //                 <div className='position-relative d-flex align-items-center justify-content-end '>
    //                   <div title='Net Debit'>Net Debit</div>
    //                 </div>
    //               </button>
    //             </th>

    //             <th className='text-end '>
    //               <button className='btn srt-btn'>
    //                 <div className='position-relative d-flex align-items-center justify-content-end '>
    //                   <div title='Net Credit'>Net Credit</div>
    //                 </div>
    //               </button>
    //             </th>

    //           </tr>
    //         </thead>

    //         <tbody>
    //           <tr>
    //             <td className='text-start fw-bold'>Assets</td>
    //             <td className='text-end'>&nbsp;</td>
    //             <td className='text-end'>&nbsp;</td>
    //           </tr>

    //           <tr>
    //             <td className='text-start fw-bold'>Liabilities</td>
    //             <td className='text-end'>&nbsp;</td>
    //             <td className='text-end'>&nbsp;</td>
    //           </tr>

    //           <tr>
    //             <td className='text-start fw-bold'>Equities</td>
    //             <td className='text-end'>&nbsp;</td>
    //             <td className='text-end'>&nbsp;</td>
    //           </tr>

    //           <tr>
    //             <td className='text-start fw-bold'>Income</td>
    //             <td className='text-end'>&nbsp;</td>
    //             <td className='text-end'>&nbsp;</td>
    //           </tr>

    //           <tr>
    //             <td className='text-start fw-bold'>Expense</td>
    //             <td className='text-end'>&nbsp;</td>
    //             <td className='text-end'>&nbsp;</td>
    //           </tr>

    //           <tr>
    //             <td className='text-start fw-bold'>Total for Trial Balance	</td>
    //             <td className='text-end'>0.00</td>
    //             <td className='text-end'>0.00</td>
    //           </tr>
              
    //         </tbody>
    //       </table>

    //       <div className='position-sticky start-0'>
    //         <div className='px-4 mb-1 py-3' >
    //           <small style={{ fontSize: '12px' }}>**Amount is displayed in your base currency</small>
    //           &nbsp;
    //           <small style={{ fontSize: '9.75px' }} className='badge bg-success d-inline rounded-0'>INR</small>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  )
}

export default TrialBalance